import { useState, useEffect, useRef } from "react";
import ModalShell from "./ModalShell";
import { sanitizeText } from "@utils/sanitize";

export default function ActionNotesModal({
  isOpen,
  onClose,
  appointment,
  onSave,
  isSaving = false,
  error = null,
  // {active, undone} once a saved note stopped campaign calls to this
  // number (or the row already carried a campaign_decline_id), else null.
  campaignDecline = null,
  onUndoCampaignDecline,
  isUndoing = false,
}) {
  const [notes, setNotes] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (isOpen && appointment) {
      setNotes(appointment.action_notes || "");
      setTimeout(() => textareaRef.current?.focus(), 100);
    }
  }, [isOpen, appointment]);

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      isSaving={isSaving}
      error={error}
      title="Action Notes"
      appointment={appointment}
      saveLabel="Save Notes"
      onSubmit={() => !isSaving && onSave(sanitizeText(notes))}
    >
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Notes
      </label>
      <textarea
        ref={textareaRef}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Document your actions here...

e.g., Called patient back - left voicemail
      Confirmed appointment for Monday at 2pm
      Patient requested reschedule to next week"
        className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm shadow-sm placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 resize-none transition-shadow"
        rows={6}
        disabled={isSaving}
      />
      <div className="mt-2 flex items-center justify-between text-xs text-gray-500">
        <span>{notes.length} characters</span>
        <span className="italic">Press Esc to close</span>
      </div>
      {campaignDecline?.active && (
        <p
          role="status"
          className="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800"
        >
          Campaign calls stopped for this number
          <span aria-hidden="true" className="mx-1.5 text-amber-400">
            ·
          </span>
          <button
            type="button"
            onClick={onUndoCampaignDecline}
            disabled={isSaving || isUndoing}
            className="font-medium underline underline-offset-2 hover:text-amber-900 focus:outline-none focus:ring-2 focus:ring-amber-300 rounded disabled:opacity-50 disabled:no-underline"
          >
            {isUndoing ? "Undoing…" : "Undo"}
          </button>
        </p>
      )}
      {campaignDecline?.undone && !campaignDecline.active && (
        <p
          role="status"
          className="mt-3 rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-800"
        >
          Campaign calls resumed for this number
        </p>
      )}
    </ModalShell>
  );
}
